var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityAndAutomationSdkMonochrome = function SvgSecurityAndAutomationSdkMonochrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57,
    fill: "none",
    viewBox: "0 0 56 57"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#security-and-automation-sdk-monochrome_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 55,
    y: 21.5,
    stroke: "#fff",
    rx: 1,
    transform: "rotate(180 55 21.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 11.5,
    r: 4,
    stroke: "#fff",
    transform: "rotate(180 45 11.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 1,
    y: 15.5,
    stroke: "#454549",
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 25.5,
    r: 4,
    stroke: "#454549"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 1,
    y: 35.5,
    stroke: "#454549",
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 45.5,
    r: 4,
    stroke: "#454549"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 21,
    y: 35.5,
    stroke: "#454549",
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 45.5,
    r: 4,
    stroke: "#454549"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "security-and-automation-sdk-monochrome_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h56v56H0z"
  })))));
};
export default SvgSecurityAndAutomationSdkMonochrome;